import React, { Component } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Toast from "../comps/alertMessage";
import * as aserver from '../../APIClient';
import * as utils from '../../Utilities';
import Modal from '../comps/modal';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));

class Templates extends Component {  constructor(props) {
    super(props);
    this.state = {
      coachId: localStorage.getItem('Id'),
      level:"",
      message:"",
      textChanged:false,
      emailText: "",
      revert:false,
      language: 'english',
      usingFallback: false,
      confirmationFunction: this.confirmationFunction,
      confirmationModal: false,
      };
  }

  closeModal = () => {
    this.setState({
      confirmationModal: false,
    });
  }

  getTemplate = async() =>{
    const { coachId } = this.state;

    const { language } = this.state;

    let results = await aserver.get(`api/v2/coaches/${coachId}/emailtemplates/`+document.getElementById('template-select').value+`?language=${language}`);
    // the template returned may be a fallback (your english template, or the default) rather than one in this language
    const returnedLanguage = results.data[0].language || 'english';
    const isCustomizedInThisLanguage = results.data[0].coachId > 0 && returnedLanguage === language;
    this.setState({
      revert: isCustomizedInThisLanguage,
      usingFallback: returnedLanguage !== language
    })
    document.getElementById('templateText').value = results.data[0].emailText;
    this.setState({
      emailText: results.data[0].emailText,
      textChanged: false,
    })
}

  showToast = () => {
    this.setState(
      {
        showToast: true
      },
      () => {
        setTimeout(() => this.setState({ showToast: false }), 3000);
      }
    );
  }

  toastMessage = (text, level) =>{
    this.setState({
      modalIsOpen:false,
      message:text,
      level: level,
      textChanged: false,
    })
    this.showToast()
  }

  change = ()=> {
    this.getTemplate()
  }

  changeLanguage = (e)=> {
    this.setState({ language: e.target.value }, this.getTemplate)
  }

  updateTemplate = async() => {
    const { coachId } = this.state;
    let results = await aserver.put(`api/v2/coaches/${coachId}/emailtemplates/`+document.getElementById('template-select').value,
      {
          emailText: document.getElementById('templateText').value,
          language: this.state.language
      });
      if(results.status === 200){
        this.setState({
          emailText: document.getElementById('templateText').value,
          revert:true,
          usingFallback:false
        })
        this.toastMessage("Successful", "success")
      }else {
        this.toastMessage("Error, Unsuccessful", "danger")
      }  
  } 

  updateValue=()=>{
    let textArea = document.getElementById("templateText").value
    if(textArea === this.state.emailText){
      this.setState({
        textChanged: false,
      })
    }else{
      this.setState({
        textChanged: true,
      })
    }
  }

  openRevertTemplateToDefault =()=>{
    this.setState({
      confirmationModal:true,
      confirmationModalText: `Are you sure? This will delete your customized template, which cannot be undone.`,
      confirmationHeading: "Confirmation",
      confirmationFunction: (e)=>this.revertTemplateToDefault(e),
    })
  }

  revertTemplateToDefault=async()=>{
      let revert = await aserver.del(`api/v2/coaches/${this.state.coachId}/emailtemplates/`+document.getElementById('template-select').value+`?language=${this.state.language}`)
      if(revert.status === 200){
        this.toastMessage("Reverted succesfully","success")
        this.closeModal()
        this.getTemplate()
      }
  }

componentDidMount() {
  this.getTemplate()
}
  render() {
    const classes = this.props.classes;
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    return (
            <>
            <div className={classes.root}>
                <CssBaseline />
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Container maxWidth="lg" className={classes.container}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Paper className={fixedHeightPaper}>
                          <>
                            <div>Choose a template:</div>
                            <div className="styled-select">
                              <select onChange={this.change} name="templates" id="template-select" defaultValue="ennea_invite">
                                <option value="ennea_invite">{utils.assessmentCodeToName('ennea')} Invite</option>
                                <option value="imf_invite">{utils.assessmentCodeToName('EIT')} Invite</option>
                                <option value="full_invite">{utils.assessmentCodeToName('full')} Invite</option>
                                <option value="send_reports">Send Reports</option>
                                <option value="send_reports_pair">Send Pair Reports (Couples / Colleagues)</option>
                                <option value="self_register">Self-register Invite</option>
                                <option value="self_register_send_reports">Self-register Send Report</option>
                                <option value="pair_register_send_reports">Pair Self-register Send Report</option>
                              </select>  
                            </div>
                            <br/>

                            <div>Language:</div>
                            <div className="styled-select">
                              <select onChange={this.changeLanguage} name="templateLanguage" id="template-language-select" value={this.state.language}>
                                {[...aserver.Languages].sort((a, b) => aserver.LanguageMap[a].localeCompare(aserver.LanguageMap[b])).map(l => <option key={l} value={l}>{aserver.LanguageMap[l]}</option>)}
                              </select>
                            </div>
                            <p>Emails are sent in the language of the client's assessment. If you haven't customized a template in that language, your English template is used instead (or the standard Aephoria template, if you haven't customized that either).</p>
                            {this.state.usingFallback && <p><b>You don't have a {aserver.LanguageMap[this.state.language]} version of this template yet, so the text below is the English fallback. Edit and update it to create a {aserver.LanguageMap[this.state.language]} version.</b></p>}

                            <div>Email template text:</div>
                            <textarea id="templateText" rows="15" cols="75" onInput={this.updateValue}>
                            </textarea>    
                            <br/>

                            <Button variant="contained" disabled={this.state.textChanged?false:true} color="primary" onClick={()=>this.updateTemplate()}>Update Template</Button>
                            <Button variant="contained" disabled={this.state.revert?false:true} color="primary" onClick={()=>this.openRevertTemplateToDefault()}>Revert template to default</Button>

                            <p>You can use the following placeholders in an email template. Please use them exactly as shown, including the curly brackets. When editing a template, it's always best to then send an email first to yourself, to check if the placeholders are correctly filled in. </p>
                            <p>&#123;guestemail&#125; = client's email</p>
                            <p>&#123;guestname&#125; = client's name</p>
                            <p>&#123;guestsurname&#125; = client's surname</p>
                            <p>&#123;coachname&#125; = your name</p>
                            <p>&#123;coachsurname&#125; = your surname</p>
                            <p>&#123;coachemail&#125; = your email address</p>
                            <p>&#123;reportlinks&#125; = link to the reports, with Aephoria standard preamble</p>
                            <p>&#123;reportlinkonly&#125; = link to the reports, nothing else</p>
                            <p>&#123;assessmentlink&#125; = link to the assessment</p>
                            <Toast
                              level={this.state.level}
                              message={this.state.message}
                              visible={this.state.showToast}
                            />
                          </>

                          <Modal isOpen={this.state.confirmationModal} onClose={() => this.closeModal()}>
                              <h3>{this.state.confirmationHeading}</h3>
                              {this.state.confirmationModalText}
                              <br/><br/>  
                              <Button variant="contained" color="primary" type="submit" onClick={()=>this.state.confirmationFunction(true)}>Ok</Button>
                              <Button variant="contained" color="primary" type="submit" onClick={()=>this.closeModal()}>Cancel</Button>
                          </Modal>
                          </Paper>
                        </Grid>
                    </Container>
                </main>
            </div>
     </>
    );
  }
}
 
// eslint-disable-next-line
export default () => {
    const classes = useStyles();
    return (
        <Templates classes={classes} />
    )
};